import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { Information } from "../../../../images/icons/Information";
import {
  ActivityScaleWrapper,
  Gradient,
  InfoItem,
  InfoItemsWrapper,
} from "./styles";

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FFFFFF",
    color: "#191A1D",
    boxShadow: theme.shadows[1],
    fontSize: 14,
    padding: 12,
  },
}));

export const ActivityScale = () => {
  return (
    <ActivityScaleWrapper>
      <Gradient />
      <InfoItemsWrapper>
        <InfoItem>
          <span>Высокая активность</span>
          <LightTooltip
            placement="top"
            title="Много мастеров, много заявок"
            sx={{ zIndex: 1000 }}
            arrow
          >
            <div>
              <Information />
            </div>
          </LightTooltip>
        </InfoItem>

        <InfoItem>
          <span>Средняя активность</span>
          <LightTooltip
            placement="top"
            title="Среднее количество мастеров, среднее количество заявок"
            sx={{ zIndex: 1000 }}
            arrow
          >
            <div>
              <Information />
            </div>
          </LightTooltip>
        </InfoItem>

        <InfoItem>
          <span>Низкая активность</span>
          <LightTooltip
            placement="top"
            title="Мало мастеров, мало заявок"
            sx={{ zIndex: 1000 }}
            arrow
          >
            <div>
              <Information />
            </div>
          </LightTooltip>
        </InfoItem>
      </InfoItemsWrapper>
    </ActivityScaleWrapper>
  );
};
